import { MouseEvent, useCallback, useState } from 'react';
import debounce from 'lodash.debounce';

export default useSearch;

interface IResult {
  searchValue: string;
  setSearchValue: (value: string) => void;
  inputValue: string;
  setInputValue: (value: string) => void;
  handleSearch: (event: MouseEvent) => void;
}

function useSearch(): IResult {
  const [searchValue, setSearchValue] = useState('');
  const [inputValue, setInputValue] = useState('');

  const debouncedSetSearchValue = useCallback(
    debounce(setSearchValue, 200),
    []
  );

  function handleSearch(event: MouseEvent): void {
    const value = (event.target as any).value;
    // inputValue quickly updates the value of the input
    setInputValue(value);
    // searchValue gets send to the API and is debounced
    debouncedSetSearchValue(value);
  }

  return {
    searchValue,
    setSearchValue,
    inputValue,
    setInputValue,
    handleSearch,
  };
}
